import Loading from '@/components/common/loading';
import { TableMobile } from '@/components/common/table/mobile';
import { PageSize } from '@/constant';
import { memo } from 'react';

import { IUpdateHistoryProps } from '../type';
import { useLogic } from './logic';

const UpdateHistoryMobile: React.FC<IUpdateHistoryProps> = (props) => {
	const { columns, total, onPageChange, loading } = useLogic(props);
	return (
		<div>
			<Loading isLoading={loading} className="m-0" />
			<div className="bg-white min-h-[122px] relative">
				<TableMobile
					dataMobile={columns}
					isHideTotal
					tableClassName="!pb-[60px] relative min-h-[122px]"
					totalRecord={total}
					pageSize={PageSize.XXXS}
					paginationClassName="!py-[13px] absolute bottom-0 left-[-18px] !w-[100vw]"
					customClassItem="first:pt-0"
					onChangePagination={onPageChange}
					isShowNo
				/>
			</div>
		</div>
	);
};

export default memo(UpdateHistoryMobile);
